export const sender = function() {
  return function(input) {
    if (!input) return null;
    if (!input.email) return null;
    if (!input.name) return input.email; 
    return `${input.name} <${input.email}>`;
  };
};